class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    
    console.log('sdfdf');
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code?.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    this.initializeDentalLicenseValidation();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    this.initializeDentalLicenseValidation();
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
    this.initializeDentalLicenseValidation();
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
  initializeDentalLicenseValidation() {
     const dentalLicenseInput = document.getElementById('dental-license');
    // const checkoutButton = document.getElementById('checkout');
    const checkoutButtonDrawer = document.getElementById('CartDrawer-Checkout');
    const errorMessage = document.getElementById('error-message');
    
    function validateInput() {
        const licenseValue = dentalLicenseInput.value.trim();

         dentalLicenseInput.value = licenseValue.replace(/[^\w\-.]/g, '');

        if (dentalLicenseInput.value.length !== 0 &&  dentalLicenseInput.value.length > 12) {
           // if(checkoutButton){
           //  checkoutButton.disabled = true;
           // }
           if(checkoutButtonDrawer){ 
            checkoutButtonDrawer.disabled = true;
           }
            errorMessage.style.display = 'block';
            errorMessage.innerText = 'Dental License must be up to 12 characters maximum.';
        } else if(dentalLicenseInput.value.length === 0) {
         if (typeof window.updateCheckoutButtonState === 'function') {
            window.updateCheckoutButtonState().catch(console.error);
          } else {
            console.error('updateCheckoutButtonState is not defined or not loaded yet');
          }
        } else {
          // if(checkoutButton){
          //   checkoutButton.disabled = false;
          // }
           if(checkoutButtonDrawer){ 
              checkoutButtonDrawer.disabled = false;
           }
            errorMessage.style.display = 'none';
        }
    }

    dentalLicenseInput.addEventListener('input', function(event){
     validateInput()
    });
   validateInput();

    // login drawer
     // const drawer = document.querySelector('[data-login-drawer]');
     //  const overlay = document.querySelector('[data-login-overlay]');
     //  const closeBtn = document.querySelector('[data-drawer-close]');
     
     //  function openDrawer() {
     //    drawer.classList.add('active');
     //    overlay.classList.add('active');
     //    document.body.style.overflow = 'hidden';
     //  }
    
     //  function closeDrawer() {
     //    drawer.classList.remove('active');
     //    overlay.classList.remove('active');
     //    document.body.style.overflow = '';
     //  }
    
     //  document.querySelectorAll('[data-checkout-button]').forEach(button => {
     //    button.addEventListener('click', function(e) {
     //      if (!isCustomerLoggedIn()) {
     //        e.preventDefault();
     //        openDrawer();
     //      }
     //    });
     //  });
    
     //  if (closeBtn) {
     //    closeBtn.addEventListener('click', closeDrawer);
     //  }
     //  if (overlay) {
     //    overlay.addEventListener('click', closeDrawer);
     //  }
     //  document.addEventListener('keydown', function(e) {
     //    if (e.key === 'Escape') {
     //      closeDrawer();
     //    }
     //  });
  
 }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
